import { getCategoryById } from '../utils/categories.js';
import { timeAgo, truncate } from '../utils/helpers.js';

/**
 * Render the report list in the sidebar.
 */
export function renderSidebar(reports, onCardClick) {
  const list = document.getElementById('report-list');

  // Update count
  const countEl = document.querySelector('.count-number');
  if (countEl) countEl.textContent = reports.length;

  if (reports.length === 0) {
    list.innerHTML = `
      <div style="text-align:center;padding:32px 16px;color:var(--text-muted);font-size:13px;">
        <p>Нет отчётов по заданным фильтрам</p>
      </div>`;
    return;
  }

  list.innerHTML = reports
    .map((r) => {
      const cat = getCategoryById(r.category);
      return `
      <div class="report-card" data-id="${r.id}">
        <div class="report-card-header">
          <span class="report-badge" style="background:${cat.colorLight};color:${cat.color}">
            ${cat.name}
          </span>
        </div>
        <div class="report-card-title">${r.title}</div>
        <div class="report-card-meta">
          <span>${timeAgo(r.created_at)}</span>
          <span class="upvotes">▲ ${r.upvotes || 0}</span>
        </div>
      </div>`;
    })
    .join('');

  // Card click handlers
  list.querySelectorAll('.report-card').forEach((card) => {
    card.addEventListener('click', () => {
      const report = reports.find((r) => r.id === card.dataset.id);
      if (report) onCardClick(report);
    });
  });
}

/**
 * Wire up sidebar open/close.
 */
export function initSidebarToggle() {
  const sidebar = document.getElementById('sidebar');
  const overlay = document.getElementById('sidebar-overlay');
  const openBtn = document.getElementById('sidebar-toggle');
  const closeBtn = document.getElementById('sidebar-close');

  const open = () => { sidebar.classList.add('open'); overlay.classList.add('active'); };
  const close = () => { sidebar.classList.remove('open'); overlay.classList.remove('active'); };

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
}
